import * as React from 'react';
import _ from 'lodash';

import { PinCell, PinCellText, PinCellAction } from 'components/Tables/grid/withPinnedCols/StyledComponents';
import PushPinIcon from '@mui/icons-material/PushPin';

const withPinnedCols = (WrappedComponent) => {
  const PinnedCols = (props) => {
    const { getItem, onPinClick, permanentlyPinned = [], pinnedCols, meta } = props;
    const [cols, rows] = meta;
    const titleRow = _.get(rows, [0]);

    const withGetItems = (row, col) => {
      const item = getItem(row, col);
      const isLastPinnedCol = pinnedCols.length === 1 && pinnedCols.includes(col);

      return titleRow === row ? (
        <PinCell>
          <PinCellText>{item}</PinCellText>
          {cols.length > 1 && (
            <PinCellAction
              tabIndex={-1}
              pinned={pinnedCols.includes(col)}
              disabled={isLastPinnedCol}
              onClick={() => {
                onPinClick(col);
              }}
            >
              <PushPinIcon sx={{ fontSize: 14 }} />
            </PinCellAction>
          )}
        </PinCell>
      ) : (
        item
      );
    };

    return <WrappedComponent {...props} getItem={withGetItems} />;
  };

  return PinnedCols;
};

export default withPinnedCols;
